import styled from '@emotion/styled';

export const CardList = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing[8],
}));

export const EmptyCard = styled('div')(({ theme }) => ({
  padding: theme.spacing[24],
  borderRadius: theme.radius[16],
  backgroundColor: theme.colors.background.raised,
}));
